import React, { FC } from 'react';
import PageHeaderComponent from '@features/common/components/PageHeaderComponent/PageHeaderComponent';
import { Paper } from '@mui/material';
import TabComponent from '@features/common/layout/TabComponent/TabComponent';
import NotificationManagementComponent
    from '@features/settings/NotificationManagementComponent/NotificationManagementComponent';
import OperationsComponent from '@features/settings/OperationsComponent/OperationsComponent';
import GeneralTabComponent from '@features/settings/GeneralTabComponent/GeneralTabComponent';
import styles from './SettingsViewComponent.module.scss';

interface SettingsViewComponentProps {
}

const SettingsViewComponent: FC<SettingsViewComponentProps> = () => (
    <div className={styles.SettingsViewComponent} data-testid="SettingsViewComponent">
        <PageHeaderComponent
            title="Settings"
        />
        <Paper>
            <TabComponent
                tabs={[
                    {
                        label: 'General',
                        TabbedContent: <GeneralTabComponent />,
                    },
                    {
                        label: 'Notifications',
                        TabbedContent: <NotificationManagementComponent />,
                    },
                    {
                        label: 'System Operations',
                        TabbedContent: <OperationsComponent />,
                    },
                ]}
            />
        </Paper>
    </div>
);

export default SettingsViewComponent;
